__turbopack_context__.v({
  "disclaimer": "cYoDoq_disclaimer",
  "editButton": "cYoDoq_editButton",
  "icon": "cYoDoq_icon",
  "item": "cYoDoq_item",
  "list": "cYoDoq_list",
});
